import { render, staticRenderFns } from "./ResetFamilyHubUserPassword.vue?vue&type=template&id=1370fda5&scoped=true"
import script from "./ResetFamilyHubUserPassword.vue?vue&type=script&lang=ts"
export * from "./ResetFamilyHubUserPassword.vue?vue&type=script&lang=ts"
import style0 from "./ResetFamilyHubUserPassword.vue?vue&type=style&index=0&id=1370fda5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1370fda5",
  null
  
)

export default component.exports